/**
 * @file Re-exports the second factor prompt banner.
 */
import SecondFactorAlert from "./SecondFactorAlert";

export default SecondFactorAlert;
